// Redaction helpers for values that end up in LoggerService output. Debug logging is opt-in via
// ?debug-key, but the console is routinely screenshotted or pasted into tickets - so identifiers
// that are useful for diagnosis get logged, and anything directly personal gets masked first.

// Keeps enough of an address to recognise the account without exposing it: jmayer@vivli.org -> j***@vivli.org
export const maskEmail = (email?: string): string => {
    if (!email) {
        return '(none)';
    }

    const atIndex = email.indexOf('@');
    if (atIndex < 1) {
        return '(masked)';
    }

    return `${email[0]}***${email.slice(atIndex)}`;
};
